import getConfig from 'next/config'
import {
  FAS,
  SMT,
  POX,
  CAP,
  ARD,
  BQP,
  XPZ,
  PLK,
  TAP,
  CLX,
  ALT,
  FTN,
} from '@fe/common/constants/brands'
import {
  BLUE,
  GREEN,
  GINGER,
  TURQUOISE,
  NAVY,
  OCEANIC,
  LAVENDER,
  SAPPHIRE,
} from '@fe/common/constants/themes'

export const getTheme = () => {
  const { publicRuntimeConfig } = getConfig() ?? {}

  switch (publicRuntimeConfig?.brandName) {
    case FAS:
      return BLUE

    case SMT:
      return TURQUOISE

    case POX:
      return GINGER

    case CAP:
      return GINGER

    case ARD:
      return GREEN

    case BQP:
      return GINGER

    case XPZ:
      return NAVY

    case PLK:
      return OCEANIC

    case TAP:
      return LAVENDER

    case CLX:
      return GINGER

    case ALT:
      return GINGER

    case FTN:
      return SAPPHIRE

    default:
      return GINGER
  }
}
